import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaHistory, FaRoute, FaTrain, FaWrench } from 'react-icons/fa';
import { Heading, PageTitle } from '../../../components';
import { timelineData } from '../../../constants';
import '../KolejWaskotorowa.css';

const KolejWaskotorowaHistoria = () => {
    const { t } = useTranslation();

    // Zabezpieczenie przed błędem, gdyby timelineData nie było tablicą
    const safeTimelineData = Array.isArray(timelineData) ? timelineData : [];

    return (
        <>
            <PageTitle
                title={t('history.pageTitle', 'Kolej Wąskotorowa / Historia')}
                page={t('history.page', 'Historia')}
                heading={t('history.heading', 'Ponad sto lat torów')}
                subTitle={t('history.subTitle', 'Od wojskowych transportów, przez epokę Kujawskiego Kolosa, aż po ratunkowe działania dzisiejszych pasjonatów.')}
            />

            <section className='kw-section kw-history'>
                <div className='kw-container'>
                    
                    {/* Panel wprowadzający (Hero block dla historii) */}
                    <div className='kw-overview-grid' style={{ marginBottom: '4rem' }}>
                        <div className='kw-manifest-box'>
                            <div className='kw-panel-label'>
                                <FaTrain />
                                <span>{t('history.manifest.label', 'Potęga Złotego Wieku')}</span>
                            </div>
                            <h3>{t('history.manifest.title', 'Kujawski Kolos')}</h3>
                            <p>{t('history.manifest.desc', 'W latach 50. sieć wąskotorowa na Kujawach była fenomenem na skalę krajową.')}</p>
                            <ul>
                                <li>{t('history.manifest.bullet1', 'Rozciągała się na długość prawie 1500 kilometrów.')}</li>
                                <li>{t('history.manifest.bullet2', 'Łączyła regiony pozwalając na przejazd z Ozorkowa aż do Gniezna.')}</li>
                                <li>{t('history.manifest.bullet3', 'Sercem sieci była stacja Krośniewice – największa zachowana stacja kolei wąskotorowej w Polsce.')}</li>
                            </ul>
                        </div>

                        <div className='kw-copy-box'>
                            <div className='kw-lead-icon'>
                                <FaWrench />
                            </div>
                            <p>
                                {t('history.copyBox', 'W Krośniewicach zachował się unikalny kompleks: lokomotywownia, wagonownia, tokarnia, a nawet odlewnia i kuźnia, tworzące spójny obszar industrialny z nieotynkowanej cegły. Cała stacja wpisana jest do rejestru zabytków jako przestrzenny układ komunikacyjny.')}
                            </p>
                        </div>
                    </div>

                    <Heading 
                        title={t('history.timelineHeading', 'Oś czasu')} 
                        subTitle={t('history.timelineSubHeading', 'Jak zmieniała się Kujawska Kolej Dojazdowa na przestrzeni dziesięcioleci')} 
                        sideHeading 
                    />

                    <div className='kw-timeline'>
                        {safeTimelineData.map((item, idx) => (
                            <article key={item.id} className={`kw-timeline-item ${idx % 2 === 1 ? 'even' : 'odd'}`}>
                                <div className='kw-timeline-image'>
                                    <img src={item.image} alt={t(item.titleKey)} />
                                    {item.captionKey && <small className='kw-image-caption'>{t(item.captionKey)}</small>}
                                </div>

                                <div className='kw-timeline-content'>
                                    <div className='kw-timeline-marker'>
                                        <FaRoute />
                                    </div>
                                    <span>{item.phase}</span>
                                    <h3>{t(item.titleKey)}</h3>
                                    <p>{t(item.textKey)}</p>
                                </div>
                            </article>
                        ))}
                    </div>

                    <div className='kw-note-box' style={{ marginTop: '4rem' }}>
                        <FaHistory className='kw-note-icon' />
                        <div>
                            <h3>{t('history.note.title', 'Pamięć wciąż żywa')}</h3>
                            <p>
                                {t('history.note.text', 'Jeśli posiadasz własne wspomnienia, fotografie albo informacje związane z tą linią, koniecznie podziel się nimi ze Stowarzyszeniem. Razem możemy zachować to niezwykłe dziedzictwo.')}
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            
            <footer className="site-footer">
                <p>{t('history.footer', 'Zdjęcia wykonał Michał Zajfert, rok 1993')}</p>
            </footer>
        </>
    );
};

export default KolejWaskotorowaHistoria;